module.exports = __webpack_public_path__ + "static/media/leaf-icon.8e71feb7.svg";